import Config from '../../../../../constnats/config';
import { DescriptorProps } from '../../../../../constnats/descriptor';
import { ReportField } from '../../../../../constnats/reportConstants';
import DescriptorType from '../../../../../utils/descriptor/descriptorType';
import ObjCheck from '../../../../../utils/objCheck';
import Utils from '../../../../../utils/utils';
import EntityFactory from './table/cellEntity';

function getRiskyDynamicFieldsChanges(entities) {
    const changes = [];
    for (const entity of entities) {
        if (entity.dynamicField === true) {
            let oldData = entity.getOriginalData();
            if (ObjCheck.isNullUndefinedEmptyOrDash(oldData)) {
                oldData = '';
            }

            let newData = entity.getData();
            if (ObjCheck.isNullUndefinedEmptyOrDash(newData)) {
                newData = '';
            }

            if (oldData !== newData) {
                changes.push({
                    descriptorId: entity.getDescriptor()[DescriptorProps.ID],
                    label: entity.getDescriptor()[DescriptorProps.LABEL],
                    old: oldData,
                    new: newData,
                });
            }
        }
    }

    return changes;
}

export function getReportsChanges(reportsEntities) {
    return reportsEntities.map(({ reportMetadata, entities }) => {
        return {
            reportMetadata,
            changes: getRiskyDynamicFieldsChanges(entities),
        };
    });
}

export function getReportsEntries(reports, descriptors) {
    const reportsEntities = reports.map((report) => {
        const entities = new EntityFactory(() => {}).create(descriptors, report);
        return {
            reportMetadata: {
                reportId: report[ReportField.ID],
                year: report[ReportField.YEAR],
                period: report[ReportField.PERIOD],
                version: report[ReportField.TYPE],
                format: report[ReportField.REPORT_TYPE],
                source: report[ReportField.SRC],
            },
            entities,
        };
    });
    return reportsEntities;
}

export function getReportsChangesTableModel(reportsChanges) {
    const reports = reportsChanges
        .filter((rc) => rc.changes.length > 0)
        .map((rc) => ({
            reportMetadata: rc.reportMetadata,
            changeMap: Object.fromEntries(rc.changes.map((c) => [c.descriptorId, c])),
        }));

    const seenIds = new Set();
    const descriptors = [];
    for (const rc of reportsChanges) {
        for (const change of rc.changes) {
            if (!seenIds.has(change.descriptorId)) {
                seenIds.add(change.descriptorId);
                descriptors.push({ id: change.descriptorId, label: change.label });
            }
        }
    }

    return { reports, descriptors };
}

function flipFieldValue(entity) {
    const descriptor = entity.getDescriptor();
    const isPercent = DescriptorType.isPercent(descriptor);
    if (DescriptorType.isNumber(descriptor) || isPercent) {
        let fieldValue = entity.getData();
        fieldValue = fieldValue.replace('%', '');
        if (Utils.isNumber(fieldValue)) {
            fieldValue = Utils.toReadMode(
                Utils.toNumber(fieldValue) * -1,
                Config.FLOATING_POINT_PRECISION_FOR_SCALED_NUMBERS,
            );
        }
        if (isPercent) {
            fieldValue += '%';
        }
        entity.setData(fieldValue);
    }
}

export function flipReportsFieldValue(reportsEntities, descriptorId) {
    reportsEntities.forEach(({ entities }) => {
        const entity = entities.find((e) => e.getDescriptor()[DescriptorProps.ID] === descriptorId);
        if (entity) {
            flipFieldValue(entity);
        }
    });
}
